import { render, staticRenderFns } from "./DownloadFilesModal.vue?vue&type=template&id=4ca16a36&scoped=true"
import script from "./DownloadFilesModal.vue?vue&type=script&lang=js"
export * from "./DownloadFilesModal.vue?vue&type=script&lang=js"
import style0 from "./DownloadFilesModal.vue?vue&type=style&index=0&id=4ca16a36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca16a36",
  null
  
)

export default component.exports